import { PrzejscieModDescriptionEnum } from 'api/strefy/strefy.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { Table } from 'ui/table/Table';
import { PassagesTableRowProps } from '../PassagesList.types';

import * as Styled from './PassagesTableRow.styles';
import { DeletePassageContainer } from './deletePassage/DeletePassageContainer';

export const PassagesTableRow = ({ passage, isDeleteDisabled, deleteDisabledReason }: PassagesTableRowProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <Table.RowItem>{passage.tkd.numerLogicznyKontrolera}</Table.RowItem>
      <Table.RowItem>{passage.tkd.nazwa}</Table.RowItem>
      <Table.RowItem>
        <Styled.Accent>{formatMessage({ id: PrzejscieModDescriptionEnum[passage.mod] })}</Styled.Accent>
      </Table.RowItem>
      <Table.RowItem>
        <Styled.Accent>{passage.strefaPoczatkowa.nazwa}</Styled.Accent>
      </Table.RowItem>
      <Table.RowItem>
        <Styled.Accent>{passage.strefaKoncowa.nazwa}</Styled.Accent>
      </Table.RowItem>
      <DeletePassageContainer passage={passage} isDisabled={isDeleteDisabled} disabledReason={deleteDisabledReason} />
    </>
  );
};
